import { createContext, useContext, useState } from 'react'

type AlertType = 'success' | 'error' | 'info'

const ALERT_TIME = 8000

const initialState: AlertContextState = {
  text: null,
  type: null,
  link: null,
}
interface AlertContextState {
  link: string | null
  text: string | null
  type: AlertType | null
}

interface AlertContextType extends AlertContextState {
  setAlert: (text: string, type: AlertType, link?: string) => void
}

export const AlertContextStore = createContext<AlertContextType | undefined>(undefined)

export const AlertContextProvider = ({ children }) => {
  const [alertState, setAlertState] = useState(initialState)

  const setAlert = (text: string, type: AlertType, link?: string) => {
    setAlertState({ text, type, link: link || null })
    alertState
    setTimeout(() => {
      setAlertState(initialState)
    }, ALERT_TIME)
  }

  return (
    <AlertContextStore.Provider
      value={{
        setAlert,
        ...alertState,
      }}
    >
      {children}
    </AlertContextStore.Provider>
  )
}

export const useAlertContext = () => {
  const context = useContext(AlertContextStore)
  if (context === undefined) {
    throw new Error('useAlertContext must be used within a AlertContextProvider')
  }
  return context
}

export default AlertContextProvider
